(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/footerbar.tpl.html',
    '<footer class="main-footer" ui-view="footer"><div class="col-xs-12 col-sm-12 col-md-12" style="padding:0px" ng-controller="FootbarCtrl"><div class="col-xs-9 col-sm-9 col-md-9" style="padding:0px" ng-show="isBiggerScreen"><a class="copyright" href="https://www.dsa.de/de/">&copy; 2024 DSA Daten- und Systemtechnik GmbH Deutschland</a> <a class="copyright" href="https://www.dsa.de/de/datenschutzerklaerung.html">{{\'foot.dataprivacy\'| translate}}</a> <a class="copyright" href="https://www.dsa.de/de/impressum.html">{{\'foot.imprint\'| translate}}</a></div><div class="col-xs-12 col-sm-12 col-md-3" style="color:#FFFFFF;padding:0px;text-align: right;"><label ng-show="isBiggerScreen">{{ \'foot.application\' | translate }}&nbsp;V{{clientVersion}} <span ng-show="isShowGtseVersion">/ {{gtseVersion}}</span></label> <label ng-show="!isBiggerScreen" style="text-align: left">{{smallerScreenFooterText}}</label></div></div></footer>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/footerbar.tpl.js